/**
 * Indian display formats — storage / <input type="date"> / API stay ISO YYYY-MM-DD.
 *
 * Short: DD-MM-YYYY  → 15-03-2021
 * Long:  DD-MMM-YYYY → 15-Mar-2021
 */

const MMM = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function parseIsoDateParts(value) {
  if (value == null || value === "") return null;
  const s = String(value).trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (!m) return null;
  return { y: m[1], mo: m[2], d: m[3], iso: `${m[1]}-${m[2]}-${m[3]}` };
}

/** ISO → DD-MM-YYYY (Indian short display). */
export function formatDisplayDate(value, fallback = "—") {
  const p = parseIsoDateParts(value);
  if (!p) {
    if (value == null || value === "") return fallback;
    return String(value);
  }
  return `${p.d}-${p.mo}-${p.y}`;
}

/** ISO → DD-MMM-YYYY (e.g. 15-Mar-2021). */
export function formatLongDate(value, fallback = "—") {
  const p = parseIsoDateParts(value);
  if (!p) {
    if (value == null || value === "") return fallback;
    return String(value);
  }
  const mon = MMM[Number(p.mo) - 1] || p.mo;
  return `${p.d}-${mon}-${p.y}`;
}

/** Birthday / anniversary without year → DD-MMM (e.g. 15-Mar). */
export function formatMonthDay(value, fallback = "—") {
  const p = parseIsoDateParts(value);
  if (!p) {
    if (value == null || value === "") return fallback;
    return String(value);
  }
  const mon = MMM[Number(p.mo) - 1] || p.mo;
  return `${p.d}-${mon}`;
}
